/**
 * Live Topics categories (Spanish) and their assigned pill/dialog colors.
 * Colors are chosen for distinction and readability; Seguridad & Justicia uses red tones.
 */
export const LIVE_TOPICS_CATEGORIES = [
  'Actualidad',
  'Política',
  'Economía',
  'Internacional',
  'Sociedad',
  'Seguridad & Justicia',
  'Salud',
  'Educación',
  'Ciencia & Tecnología',
  'Deportes',
  'Cultura & Espectáculos',
  'Medio Ambiente',
  'Opinión',
  'Locales',
  'Other',
] as const;

const CATEGORY_COLOR_MAP: Record<string, string> = {
  Actualidad: '#4A90D9',
  Política: '#1565C0',
  Economía: '#607D8B',
  Internacional: '#2C3E50',
  Sociedad: '#00838F',
  'Seguridad & Justicia': '#C62828',
  Salud: '#00695C',
  Educación: '#FFB300',
  'Ciencia & Tecnología': '#4527A0',
  Deportes: '#EF6C00',
  'Cultura & Espectáculos': '#AD1457',
  'Medio Ambiente': '#558B2F',
  Opinión: '#5D4037',
  Locales: '#795548',
  Other: '#757575',
};

/**
 * Returns the hex color for a topic category. Unknown categories default to Other (gray).
 */
export function getCategoryColor(category: string | null | undefined): string {
  if (!category) {
    return CATEGORY_COLOR_MAP.Other ?? '#757575';
  }

  return CATEGORY_COLOR_MAP[category] ?? CATEGORY_COLOR_MAP.Other ?? '#757575';
}
